import { Checkbox, FormControlLabel, TextField } from "@mui/material"
import { IScoreType, ISport } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate"
import { FilterQuery } from "mongoose"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "../../apiClient/axios"
import { ScoreTypesApiClient } from "../../apiClient/scoreTypes"
import { SportsApiClient } from "../../apiClient/sports"
import { DEFAULTGAP } from "../../globals"
import { DropDownSearchComponent } from "../common/dropDownSearch"
import { FloatActionButton } from "../common/floatActionButton"

export const ScoreTypeComponent = (props: { id?: number }) => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()

  const [data, setData] = useState<IScoreType>()
  const [sports, setSports] = useState<ISport[]>([])
  const [saving, setSaving] = useState<boolean>(false)

  const [gettingSports, setGettingSports] = useState<boolean>(false)
  const getSports = async (where?: FilterQuery<ISport>) => {
    if (gettingSports) return []
    setGettingSports(true)

    try {
      const response = await new SportsApiClient(axios).get({
        where,
        sort: { name: 1 }
      })
      const sortedData = response.data?.payload?.sort((a, b) => a.name?.localeCompare(b.name))
      if (!where) setSports(sortedData || [])
      return sortedData || []
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
      return []
    } finally {
      setGettingSports(false)
    }
  }

  const getData = async () => {
    try {
      const response = await new ScoreTypesApiClient(axios).get({
        where: { id: Number(props.id) },
        exclude: '_id',
        sort: { name: 1 }
      })

      if (response.success && response?.data?.payload)
        setData(response.data.payload[0])

    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
  }

  const save = async () => {
    if (saving) return
    setSaving(true)

    try {
      if (data) {
        const response =
          data.id
            ? await new ScoreTypesApiClient(axios).put({ data })
            : await new ScoreTypesApiClient(axios).post({ data })

        if (response.success) {
          if (response.data?.id) data.id = response.data.id
          enqueueSnackbar('Alterações salvas com sucesso.', { variant: 'success' })
        } else {
          enqueueSnackbar(response.msg || 'Erro ao salvar alterações.', { variant: 'error' })
        }
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setSaving(false)
    }
  }

  useEffect(() => {
    getSports()

    if (props.id) {
      getData()
    } else {
      setData({} as IScoreType)
    }
  }, [])

  return (
    <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP}>
        <TextField
          InputLabelProps={{ shrink: true }}
          value={data?.name || ''}
          label="Nome"
          onChange={(e) =>
            setData({
              ...data,
              name: e.target.value
            } as IScoreType)
          }
        />
      </FormItemStyled>

      <FormItemStyled gap={DEFAULTGAP}>
        <DropDownSearchComponent
          initInputValue={sports.find(s => s.id === data?.sport_id)?.name}
          progress={gettingSports}
          label="Esporte"
          modelLabelName="name"
          dataBuilder={async (typedText: string | undefined) => {
            if (typedText)
              return await getSports({
                name: { $regex: typedText, $options: 'i' }
              })
            return sports
          }}
          onSelectItem={(item: ISport) => {
            setData(prev => ({
              ...prev,
              sport_id: item.id
            }) as IScoreType)
          }}
          onClear={() => setData(prev => ({
            ...prev,
            sport_id: undefined
          }) as unknown as IScoreType)}
        />
      </FormItemStyled>

      <FormItemStyled gap={DEFAULTGAP} fullWidth>
        <FormControlLabel
          label='Exibir sempre'
          control={
            <Checkbox
              checked={data?.always_show ? true : false}
              onChange={e => {
                setData(prev => {
                  return {
                    ...prev,
                    always_show: e.target.checked
                  } as IScoreType
                })
              }} />
          }
        />
      </FormItemStyled>

      <FloatActionButton
        progress={saving}
        onCancelClick={() => navigate(-1)}
        onConfirmClick={save}
      />
    </FormStyled>
  )
}
